export const validateUrl = link => {
  try {
    const url = new URL(link);
    return url;
  } catch {
    return null;
  }
};